const effectiveDate = new Date('2025-05-19');

export const formatEffectiveDate = () => {
    return new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    }).format(effectiveDate);
  };
